module.exports = __webpack_public_path__ + "static/HKGrotesk-LightItalic-062b2fc082a5c79ff0464e178f4feefe.woff2";